module.exports = __webpack_public_path__ + "static/media/joy2.8efdcd80.png";